module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-10-d6d25b5f33b937aa0211bde4b647b626.png";